import React from 'react';
import MaterialUITypography, { TypographyProperties } from '../Typography';

const Headline1 = ({ tag, ...properties }: TypographyProperties) => (
  <MaterialUITypography
    tag={tag}
    variant="h1"
    {...properties}
  />
);

export default Headline1;
